export enum ButtonThemes {
  Primary = 'primary',
  PrimaryDark = 'primary-dark',
  PrimaryLight = 'primary-light',
  Secondary = 'secondary',
  SecondaryWhiteBackground = 'secondary-white-background',
  Danger = 'danger',
  DangerDarker = 'danger-darker',
  DangerDarkerOutline = 'danger-darker-outline',
  Default = 'default',
  Black = 'black',
  DefaultPrimary = 'default-primary',
  Blue = 'blue',
  Pauta = 'pauta',
  HeaderPrimary = 'header-primary',
  HeaderSecondary = 'header-secondary',
  HeaderUserPrimary = 'header-user-primary',
  HeaderUserSecondary = 'header-user-secondary',
  HeaderUserBold = 'header-user-bold',
}
